import { Jumbotron, ButtonGroup, Button } from 'react-bootstrap';

const Guarantee = () => {
    return (
        <>
            <Jumbotron>
                <h1>ТОО "Синомост"</h1>
                <h2>Гарантия на всю технику | Характеристики выше на 20% | Самая выгодная цена на рынке | Наличие и короткие сроки поставки</h2>
                <p>
                    Автомобили и Спецтехника от компании ТОО "Синомост" - гарантия качественной покупки техники. Вы получаете зоводскую гарантию абсолютно на все позиции. ТОО "Синомост" предоставляет сервис по на Автомобили и Спецтехнику. Так же, у нас Вы можете любую деталь и комплектующие, которые Вам могут пригодиться. Работая с заводом производителя на прямую, мы гарантируем Вам цены, которые приятно удивят. А налаженная система поставки позволит Вам купить любые объемы техники оптом и в розницу в максимально короткие сроки.
                </p>
                <ButtonGroup>
                    <a href="https://wa.me/77015471529" target="_blank" className="btn btn-success">Написать в Whatsapp</a>
                    <a href="tel:+77015471529" className="btn btn-light">Позвонить</a>
                </ButtonGroup>
            </Jumbotron>
        </>
    );
};

export default Guarantee;
